/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  AzzurroHubAction,
  AzzurroHubBody,
  CMDReq,
} from '..';
import {
  serializeAzzurroHubBody,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface SendCommandForAzzurroHubInput {
  deviceId: string;
  action: AzzurroHubAction;
  body: AzzurroHubBody;
  transactionId?: string;
}
const build = (_query: DocumentNode, input: SendCommandForAzzurroHubInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.action !== undefined ? `$action: AzzurroHubAction = ${input.action}, ` : '' ) + ``+
    ( input.body !== undefined ? `$body: AzzurroHubBody = ${serializeAzzurroHubBody(input.body)}, ` : '' ) + ``+
    ( input.transactionId !== undefined ? `$transactionId: String = ${JSON.stringify(input.transactionId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    sendCommandForAzzurroHub(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' } 
      ${ input.action !== undefined ? 'action: $action,' : '' } 
      ${ input.body !== undefined ? 'body: $body,' : '' } 
      ${ input.transactionId !== undefined ? 'transactionId: $transactionId,' : '' }
    ){
      ...cmdreq
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class SendCommandForAzzurroHubMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment cmdreq on CMDReq { ... }
   */
  async execute(_query: DocumentNode, input: SendCommandForAzzurroHubInput): Promise<apollo.FetchResult< { sendCommandForAzzurroHub: Partial<CMDReq> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ sendCommandForAzzurroHub: Partial<CMDReq> }>({ mutation: build(_query, input) });
  }
}
